import axios from "axios";
import toast from "react-hot-toast";

export const apiClient = axios.create({
  baseURL: "/api",
});

const refresh = async () => {
  const refreshToken = localStorage.getItem("refreshToken");
  const response = await apiClient.put("auth/session", {
    refresh_token: refreshToken,
  });
  return response.data;
};

const handleError = (error) => {
  const status = error?.response?.status;

  if (
    status >= 400 &&
    error.response.data.error.code !== 1944716797 &&
    !error.config?.skipErrorToast
  ) {
    toast.error("Что-то пошло не так");
  }
};

apiClient.interceptors.request.use((config) => {
  const accessToken = localStorage.getItem("accessToken");
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  return config;
});

let refreshPromise;

apiClient.interceptors.response.use(
  (config) => {
    return config;
  },
  async (error) => {
    const originalRequest = error.config;
    if (error?.response?.status === 401 && !originalRequest._isRetry) {
      if (
        error.config.url !== "auth/session" ||
        error.config.url !== "auth/signin"
      ) {
        throw error;
      }

      if (!refreshPromise) {
        refreshPromise = refresh();
      }
      originalRequest._isRetry = true;

      try {
        const data = await refreshPromise;
        localStorage.setItem("accessToken", data.refresh_token);
        localStorage.setItem("refreshToken", data.refresh_token);
        originalRequest.headers.Authorization = `Bearer ${data.access_token}`;
        return apiClient(originalRequest);
      } catch (refreshError) {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        handleError(refreshError);
      }

      refreshPromise = undefined;
      return apiClient.request(originalRequest);
    }
    handleError(error);
    return Promise.reject(error);
  },
);

/**
 *
 * @param {import("axios").AxiosRequestConfig} options
 * @returns
 */
export const axiosBaseQuery = async ({
  url,
  method = "GET",
  ...restOptions
}) => {
  try {
    const result = await apiClient.request({
      url,
      method,
      ...restOptions,
    });
    return { data: result.data };
  } catch (error) {
    handleError(error);
    const axiosError = error;
    return {
      error: {
        status: axiosError.response?.status,
        data: axiosError.response?.data || axiosError.message,
      },
    };
  }
};
